import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Language } from 'nswag/Gateway-Proxies';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TenantConfigService } from './tenant-config.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private _currentLanguage?: string;


  constructor(
    private translate: TranslateService,
    private dialog: MatDialog,
    private router: Router,
    private httpClient: HttpClient,
    private tenantConfigService: TenantConfigService
  ) { }


  get currentLanguage(): string {
    return localStorage.getItem("currentLang") as string;

  }
  set currentLanguage(value: string) {
    this._currentLanguage = value;
    localStorage.setItem("currentLang", this._currentLanguage);
    this.setHtmlLanguageAttribute();

  }
  private setHtmlLanguageAttribute() {
    const root = document.documentElement;
    const tenant = this.tenantConfigService?.tenant;
    if (this._currentLanguage === "ar") {
      document.dir = 'rtl';
      document.body.lang = 'ar';
      document.body.classList.remove('en');
      document.body.classList.add('ar');
      if (root && tenant) {
        const arFont = tenant.fontFamilyAr || tenant.fontFamily;
        if (arFont) {
          root.style.setProperty('--primary-font-family', arFont);
        }
      }
    }
    else {
      document.dir = 'ltr';
      (document as any).lang = 'en';
      document.body.lang = 'en';
      document.body.classList.remove('ar');
      document.body.classList.add('en');
      if (root && tenant) {
        const enFont = tenant.fontFamilyEn || tenant.fontFamily;
        if (enFont) {
          root.style.setProperty('--primary-font-family', enFont);
        }
      }
    }
  }
  setLanguage(lang: string) {
    this.currentLanguage = lang;
    this.translate.use(lang);
  }

  private getLanguageEnum(lang: string): Language {
    return lang === 'ar' ? Language.Ar_SA : Language.En_US;
  }

  get currentLanguageEnum(): Language {
    return this.getLanguageEnum(this.currentLanguage);
  }

  async switchLang(lang: string): Promise<void> {

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {

      width: '400px',

      disableClose: true,

      data: {

        title: 'Shared.CHANGE_LANGUAGE',

        message: 'Shared.CHANGE_LANGUAGE_WARNING'

      }

    });



    const result = await firstValueFrom(dialogRef.afterClosed());



    if (result) {
      // Call the API to change language on the server
      const languageEnum = this.getLanguageEnum(lang);
      const url = `${this.tenantConfigService.tenant.apisBaseUrl}/api/1/User/ChangeLanguage`;
      
      // Get authorization token from localStorage
      const currentUser = localStorage.getItem('currentUser');
      const token = currentUser ? JSON.parse(currentUser)?.token : null;
      
      let headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      
      if (token) {
        headers = headers.set('Authorization', `Bearer ${token}`);
      }
      
      // Send language as request body input
      const body = {
        language: languageEnum
      };
      
      try {
        await firstValueFrom(this.httpClient.post(url, body, { headers }));
      } catch (err) {
        console.error('Error changing language:', err);
      }
      
      // Change language locally and reload
      this.setLanguage(lang);
      window.location.reload();
    }

  }


}

